export default __webpack_public_path__ + "static/media/one.8b0fcba6.svg";